import _ from 'lodash';
import IApplicationState from 'app/types/state';
import { parseAmount, toTitleCase } from 'app/utils/parsers';

function mapSelect(connections, n) {
  const sa = connections.connectionsById[n];
  if (sa) {
    return { id: sa.id, name: sa.name };
  }
  return null;
}

export function getConnectionsByIdInSelectFormat(connections): any {
  return _.map(connections.connectionIds, (n) => mapSelect(connections, n));
}

export function getCurrentConnection(state: IApplicationState): any {
  if (
    state.connections.connectionsById !== undefined
    && state.connections.currentConnectionId !== undefined
  ) {
    const findConnection = state.connections.connectionsById[state.connections.currentConnectionId];
    const currentConnection = {
      ...findConnection,
    };

    return currentConnection;
  }
  return {};
}

export function getCurrentFormConnection(state: IApplicationState) {
  return {
    ...getCurrentConnection(state),
    ...state.connections.requestedData,
  };
}

export function getConnections(state: IApplicationState): any {
  return {
    ...state.connections,
    currentConnection: {
      ...getCurrentConnection(state),
    },
  };
}

export function getConnectionsByTeamId(state, teamId): any {
  if (state.connections.connectionsById !== undefined && teamId != null) {
    return _.filter(state.connections.connectionsById, { teamId });
  }
  return {};
}

export function getConnectionsByIds(connectionsById, tagIds): any {
  if (connectionsById !== undefined && tagIds != null) {
    return _.pick(connectionsById, tagIds);
  }
  return {};
}

export function getConnectionIdsByTeamId(state, teamId): any {
  if (state.connections.connectionsById !== undefined && teamId != null) {
    const filtered = _.filter(state.connections.connectionsById, {
      teamId,
    });
    if (filtered != null) {
      return _.map(filtered, 'id');
    }
    return [];
  }
  return [];
}
export function parseConnectionStatus(connection) {
  let parsedColour = 'grey';

  if (connection.status === 'active') {
    parsedColour = 'green';
  }

  return { colour: parsedColour, text: _.capitalize(connection.status) };
}
function parseConnectionTypeText(notificationType) {
  let parsedText = '';
  if (notificationType === 'forfeit-email') {
    parsedText = 'Forfeit Email';
  }
  if (notificationType === 'forfeit-sms') {
    parsedText = 'Forfeit SMS';
  }
  return parsedText;
}

function parseConnectionTypeColour(notificationType) {
  const parsedColour = 'grey';

  return parsedColour;
}

function parseConnectionType(status) {
  const statuses = [];
  const colour = parseConnectionTypeColour(status);
  const text = parseConnectionTypeText(status);

  statuses.push({ colour, text });

  return statuses;
}

export function getConnectionSummary(connection): any {
  const connectionSummary = {
    id: connection.id,
    notificationType: parseConnectionType(connection.notificationType),
    name: connection.name,
    email: connection.email,
    mobile: connection.mobile,
  };
  return connectionSummary;
}
